<template>
    <tr v-if="isEqual(o,n)">
        <td style="padding: 0 5px;"></td>
        <td class="photosResult" style="padding: 0 5px;" valign="top">
            <photo-gallery
                style="padding-left: 7%; width: 459px;  overflow: auto;"
                :id="params.key"
                v-model="res"
                :buttonText="params.buttonText"
                :uploadUrl="params.uploadUrl"
                @file-uploaded="photoUploaded"
                :doctor.sync="full"
                :imagesBasePath="path"
                :is-doctor="full.nameFamily !== undefined"
                :is-moderation="true"
            ></photo-gallery>
        </td>
        <td style="padding: 0 5px;"></td>
    </tr>
    <tr v-else>
        <td :class="{'selected': isEqual(o, res)}" style="padding: 0 5px;" valign="top">
            <div><a @click="cloneToRes(o)">{{ o.length | pluralize(presets[preset][0], presets[preset][1], presets[preset][2], presets[preset][3]) }}</a></div>
            <photo-gallery
                style="padding-left: 7%; width: 459px;  overflow: auto;"
                :id="params.key+'-old'"
                v-model="o"
                :imagesBasePath="path"
                :previewMode="true"
                :square="true"
                :is-moderation="true"
            ></photo-gallery>
        </td>
        <td class="selected photosResult" style="padding: 0 5px;" valign="top">
            <div>{{ res.length | pluralize(presets[preset][0], presets[preset][1], presets[preset][2], presets[preset][3]) }}</div>
            <photo-gallery
                style="padding-left: 7%; width: 459px;  overflow: auto;"
                :id="params.key"
                v-model="res"
                :imagesBasePath="path"
                :uploadUrl="params.uploadUrl"
                :buttonText="params.buttonText"
                @file-uploaded="photoUploaded"
                :doctor.sync="full"
                :square="true"
                :is-doctor="full.nameFamily !== undefined"
                :is-moderation="true"
            ></photo-gallery>
            <label>
                <input type="checkbox" v-model="mergePhoto">
                <span>Объединить</span>
            </label>
        </td>
        <td :class="{'selected': isEqual(n, res)}" style="padding: 0 5px;" valign="top">
            <div><a @click="cloneToRes(n)">{{ n.length | pluralize(presets[preset][0], presets[preset][1], presets[preset][2], presets[preset][3]) }}</a></div>
            <photo-gallery
                style="padding-left: 7%; width: 459px;  overflow: auto;"
                :id="params.key+'-new'"
                v-model="n"
                :imagesBasePath="path"
                :previewMode="true"
                :square="true"
                :is-moderation="true"
            ></photo-gallery>
        </td>
    </tr>
</template>
<script>
import Base from "../Base.vue";
import PhotoGallery from "@components/common/PhotoGallery";

export default {
    components: {PhotoGallery},
    mixins: [Base],
    props: {
        o: {
            type: Array,
            default: []
        },
        n: {
            type: Array,
            default: []
        },
        f: {
            type: Array,
            default: []
        },
        full: {
            type: Object,
            default: () => {},
        }
    },
    data: function () {
        return {
            presets: {
                'photo': ['$ фотографий', '$ фотография', '$ фотографии', '$ фотографий'],
                'licence': ['$ лицензий', '$ лицензия', '$ лицензии', '$ лицензий'],
            },
            path: this.params.path,
            preset: this.params.preset ?? 'photo',
            mergePhoto: false,
        }
    },
    created() {
        this.cloneArrToRes(this.res);
    },
    methods: {
        photoUploaded (uploadedImageUrls, position) {
          uploadedImageUrls.reverse().forEach((url) => {
            this.res.splice(position,0,url)
          })
        },
        cloneToRes(value) {
            this.cloneArrToRes(value)
            this.mergePhoto = false;
        }
    },
    computed: {
        path_fullsize: function () {
            let pathArr = this.path.replace(/\/$/, '').split('/');
            if (pathArr.length <= 1) {
                return '';
            } else {
                pathArr.pop();
                return pathArr.join('/') + '/fullsize/'
            }
        },
    },
    watch: {
        mergePhoto() {
            if (this.mergePhoto) {
                this.res = this.o.concat(this.n)
            } else {
                this.res = this.o.length > this.n.length ? this.o : this.n;
            }
        }
    }
}
</script>
